import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setSecretData() {
  return Cookies.set('SecretDataKey', setSecretData, { expires: new Date() + 60000 })
}

export function getSetSecretData() {
  return Cookies.get('SecretDataKey')
}
